import React from 'react';
import {Prelead, useMainCategoriesQuery} from 'api';
import {Row} from 'react-table';

interface Props {
  row: Row<Prelead>;
}

const MainCategoryCell = ({row}: Props) => {
  const prelead: Prelead = row.original;
  const {data: {mainCategories = []} = {}} = useMainCategoriesQuery();

  const targetMaincategories = React.useMemo(
    () =>
      mainCategories
        .filter((mainCategory) =>
          prelead.mainCategoryIds?.includes(mainCategory.id),
        )
        .map((mainCategory) => mainCategory.name)
        .join(', '),
    [mainCategories],
  );

  return <span>{targetMaincategories}</span>;
};

export default MainCategoryCell;
